import '@grandvisionhq/utils';
import { getUnlocalizedSpecificationItem } from '../utils/get-unlocalized-specification-item.js';
import '@swc/helpers';
import '@grandvisionhq/graphql';
import '../../../types/product.js';
import { getSpecificationItems } from '../utils/get-specification-items.js';
import { mapServerToSpecificationsBase } from './map-server-to-specifications-base.js';

const mapServerToContactLensesSpecifications = (serverVariant, brand, replacementFrequency, replacementFrequencyAllLocales)=>{
    const { packageQuantity , lensType , lensTypeAllLocales , material , materialAllLocales , materialType , waterContent ,  } = serverVariant.variantTypeDetails;
    const lensTypeUnlocalized = getUnlocalizedSpecificationItem(lensTypeAllLocales);
    const materialUnlocalized = getUnlocalizedSpecificationItem(materialAllLocales);
    const replacementFrequencyUnlocalized = getUnlocalizedSpecificationItem(replacementFrequencyAllLocales);
    const serverSpecifications = {
        lensType,
        lensTypeUnlocalized,
        material,
        materialUnlocalized,
        materialType,
        packageQuantity,
        waterContent,
        replacementFrequency,
        replacementFrequencyUnlocalized
    };
    return [
        ...mapServerToSpecificationsBase(serverVariant, brand),
        ...getSpecificationItems(serverSpecifications), 
    ];
};

export { mapServerToContactLensesSpecifications };
//# sourceMappingURL=map-server-to-contact-lenses-specifications.js.map
